import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AgencyService {

  constructor(private _activatedRoute: ActivatedRoute) { }

  async setAgencyParameters() {
    let source: any;
    let pubId: any;
    let agency: any;
    let clickId: any;
    let referer: any;
    let agencyPara: any;
    let userAgent: any;

    source = this._activatedRoute.snapshot.queryParamMap.get('source');
    sessionStorage.setItem('source', source);
    console.log('................', sessionStorage.getItem('source'));

    clickId = this._activatedRoute.snapshot.queryParamMap.get('ClkId');
    sessionStorage.setItem('clickId', clickId);
    pubId = this._activatedRoute.snapshot.queryParamMap.get('pubId');
    sessionStorage.setItem('pubId', pubId);
    referer = this._activatedRoute.snapshot.queryParamMap.get('referer') ? this._activatedRoute.snapshot.queryParamMap.get('referer') : '0';
    sessionStorage.setItem('referer', referer);
    userAgent = encodeURI(window.navigator.userAgent.toLowerCase());
    sessionStorage.setItem('userAgent', userAgent);
  }
}
